import {
  toFullString
} from '../../unit'
const MAXIMUM = 15
// initial state
const state = {
  unitObj: {
    label: '元/斤',
    value: 7
  },
  productObj: {
    cid1: '',
    cid2: '',
    product_id: '',
    breed_id: '',
    product_name: '',
    breed_name: '',
    cid1_name: '',
    cid2_name: ''
  }, // 商品名称
  title: '', // 输入框商品名称
  desc: '', // 商品描述
  suppliesSku: [], // sku价格设置
  files: [], // 上传的图片or视频
  stall: 0, // 搜索推荐位 0 未选中 1 选中优先搜索
  locationObj: { // 产地信息
    location_name: '',
    location_id: 0,
    country_code: 'CN',
    adcode: 0
  },
  vendorObj: { // 供应商信息
    customer_name: '',
    customer_id: '',
    stall: '',
    stall_name: ''
  },
  maximum: MAXIMUM
}

// getters
const getters = {
  files: state => state.files,
  unitObj: state => state.unitObj,
  vendorObj: state => state.vendorObj,
  suppliesSku: state => state.suppliesSku,
  locationObj: state => state.locationObj
}

// actions
const actions = {

}

// mutations
const mutations = {
  // 初始化state
  initialize(state) {
    state.maximum = MAXIMUM
    state.unitObj = {
      ...state.unitObj,
      label: '元/斤',
      value: 7
    }
    state.productObj = {
      ...state.productObj,
      cid1: '',
      cid2: '',
      product_id: '',
      breed_id: '',
      product_name: '',
      breed_name: '',
      cid1_name: '',
      cid2_name: ''
    }
    state.title = ''
    state.stall = 0
    state.desc = ''
    state.files = []
    state.suppliesSku = [{
      price: '',
      title: ''
    }]
    state.locationObj = {
      ...state.locationObj,
      location_id: 0,
      location_name: '',
      country_code: 'CN',
      adcode: ''
    }
    state.vendorObj = {
      customer_name: '',
      customer_id: '',
      stall: '',
      stall_name: ''
    }
  },
  // 初始化单位
  initialUnit(state, param) {
    state.unitObj = {
      ...state.unitObj,
      label: '元/斤',
      value: 7
    }
  },
  updateTitle(state, param) {
    state.title = param
  },
  // 更新stall 搜索推荐位
  updateStall(state, param) {
    state.stall = param // 更新字段类型 是否优先搜索展示
  },
  // 获取供应详情
  updateSupplyInfo(state, paramOb) {
    const {
      unit,
      category_id_lvl1,
      category_id_lvl2,
      product_id,
      breed_id,
      product_name,
      additional: desc,
      stall,
      supplies_sku,
      location_id,
      location_name,
      adcode,
      country_code,
      video_img,
      title,
      cid1_name = '',
      cid2_name = '',
      breed_name = ''
    } = paramOb
    state.title = title
    state.unitObj = {
      ...state.unitObj,
      label: toFullString(unit + ''),
      value: paramOb.unit
    }
    state.productObj = {
      ...state.productObj,
      cid1: category_id_lvl1,
      cid2: category_id_lvl2,
      product_id,
      breed_id,
      product_name: product_name,
      cid1_name,
      cid2_name,
      breed_name
    }
    state.stall = stall == 1
    state.desc = desc
    state.files = state.files.concat(video_img) // 上传的图像 视频
    state.suppliesSku = supplies_sku.map(i => {
      i.price = (i.price - '') / 100
      return i
    })
    state.locationObj = {
      ...state.locationObj,
      location_id,
      location_name,
      country_code,
      adcode
    }
    state.maximum = MAXIMUM - state.files.length
  },
  updateLocation(state, paramOb) {
    const {
      id,
      fullName,
      country_code,
      adcode
    } = paramOb
    state.locationObj = {
      ...state.locationObj,
      location_id: id,
      location_name: fullName,
      country_code,
      adcode
    }
  },
  updateProduct(state, paramOb) {
    if (paramOb && Object.keys(paramOb).length) {
      state.productObj = {
        ...paramOb
      }
    } else {
      state.productObj = {
        ...state.productObj,
        cid1: '',
        cid2: '',
        product_id: '',
        breed_id: '',
        product_name: '',
        breed_name: '',
        cid1_name: '',
        cid2_name: ''
      }
    }
  },
  updateSupplySkuPrice(state, paramOb) {
    state.suppliesSku = state.suppliesSku.map((i, idx) => {
      if (idx == paramOb.idx) {
        i.price = paramOb.value
        return i
      }
      return i
    })
  },
  updateDesc(state, val) {
    state.desc = val
  },
  updateUnit(state, val) {
    state.unitObj = Object.assign({}, {
      ...val
    })
  },
  // 更新供应商信息
  updateVendor(state, val) {
    state.vendorObj = {customer_id: val.customer_id, customer_name: val.customer_name || '', stall: val.stall || '', stall_name: val.stall_name || ''}
  },
  addSuppliesSku(state) {
    state.suppliesSku = state.suppliesSku.concat({
      price: '',
      title: ''
    })
  },
  delThisSku(state, idx) {
    state.suppliesSku.splice(idx, 1)
  },
  delFile(state, idx) {
    state.maximum = MAXIMUM - (state.files.length - 1)
    state.files.splice(idx, 1)
  },
  addFiles(state, item) { // 每个文件单次更新， item单独文件
    let file = {}
    if (item.response.status === 0) {
      var filename = item.response.data.filename
      var reg = /.mp4|.m4v$/gi
      if (item.type.indexOf('image/') > -1) {
        file = {
          id: item.id,
          p_url: filename,
          file_type: 0
        }
      } else {
        file = {
          id: item.id,
          pre_url: reg.test(filename) ? 'http://video.yimutian.com/' + filename.replace(/\.\w+$/, '.jpeg') : '',
          file_type: 1,
          v_url: item.response.data.filename
        }
      }
    }
    state.files = state.files || []
    state.files.push(file)
    state.maximum = MAXIMUM - state.files.length
  },
  updateFilesOrder(state, files) {
    state.files = files
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
